
export class ProvinciaModel {

  id: string;
  nm: string;


}
